import { Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { useUserBrands } from '@retail/app/stores/selected-context';
import { MemberConfigTable } from '@retail/member-config/components';
import { useFetchMemberConfig } from '@retail/member-config/data-access';
import { AssortmentConfig, DataOwnerConfig } from '@retail/member-config/types';
import { TagHeading } from '@shared/components';
import { useState } from 'react';
import { AssortmentsFieldsUpdateDialog } from './AssortmentsFieldsUpdateDialog';
import { ConnectAssortmentsDialogContainer } from './ConnectAssortmentsDialogContainer';

export function MemberConfigContainer() {
  const t = useAppTFunction();
  const { selectedBrand } = useUserBrands();

  const { data: memberConfigDTO = [], isLoading } = useFetchMemberConfig({
    brandId: selectedBrand.brandId,
    suspense: false,
  });
  const memberConfig = memberConfigDTO.map(DataOwnerConfig.fromDto);

  const [assortmentsForEdit, setAssortmentsForEdit] = useState<AssortmentConfig[]>([]);
  const [memberForAssortmentConnection, setMemberForAssortmentConnection] = useState<
    DataOwnerConfig | undefined
  >(undefined);

  return (
    <Stack flexGrow={1}>
      <TagHeading sx={{ px: 3, pb: 2 }}>
        <Typography variant="h4">{t('app.routes.memberConfig')}</Typography>
      </TagHeading>
      {memberConfig && (
        <MemberConfigTable
          configuration={memberConfig}
          isLoading={isLoading}
          setAssortmentsForEdit={setAssortmentsForEdit}
          setMemberForAssortmentConnection={setMemberForAssortmentConnection}
        />
      )}

      {!!assortmentsForEdit.length && (
        <AssortmentsFieldsUpdateDialog
          assortmentsForEdit={assortmentsForEdit}
          brandId={selectedBrand.brandId}
          onClose={() => setAssortmentsForEdit([])}
        />
      )}
      {memberForAssortmentConnection && (
        <ConnectAssortmentsDialogContainer
          memberForAssortmentConnection={memberForAssortmentConnection}
          onClose={() => setMemberForAssortmentConnection(undefined)}
        />
      )}
    </Stack>
  );
}
